import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import { ButtonContained } from '../components/app-button/button'
import AppBarInner from '../components/app-bar/AppBarInner'
import Wrapper from '../components/wrapper'
import AppStepper from '../components/app-stepper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import { BackIcon } from '../components/app-icon/Icons'
import TableManualCosting from '../components/table'
import CustomizeAll from '../components/сustomize-all/'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    width: 630,
    marginLeft: 74,
  },
  listChanel: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: 0,
    listStyleType: 'none',
    flexWrap: 'wrap',
  },
  ChanelItem: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 64,
    height: 64,
    marginRight: 15,
    marginBottom: 15,
    borderRadius: '100%',
    border: 'solid 1px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'rgb(255, 255, 255)',
  },
  ChanelIcon: {
    width: 35,
    height: 35,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  ChanelStatus: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100%',
    position: 'absolute',
    bottom: 0,
    right: -7,
    width: 24,
    height: 24,
    border: 'solid 1px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'rgb(255, 255, 255)',
    cursor: 'pointer',
  },
  ChanelAddIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 13,
    height: 13,
  },
  ChanelRemoveIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 13,
    height: 13,
  },
  content: {
    padding: '0 30px 30px 22px',
  },
  back: {
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    marginRight: 5,
    justifyContent: 'center',
  },
})

function getSteps() {
  return [
    `Аккаунт \nподтвержден`,
    'Сайт \nдобавлен',
    'Google Analytics \nнастроен',
    'Добавьте каналы \nдля сбора данных \nо расходах',
    'Подключение CRM\nсистемы',
    'Подключение\nколлтрекинга',
  ]
}

class GAAsync extends Component {
  state = {
    activeStep: 3,
    statistics: window.state.statistics,
  }

  render() {
    const { classes } = this.props
    const { statistics, activeStep } = this.state
    const steps = getSteps()

    return (
      <div className={classes.pageTemplate}>
        <AppBarInner />
        <CustomizeAll />

        <div className={classes.wizardRow}>
          <LeftNavigationDashboard />
          <div style={{ width: 200 }}>
            <AppStepper activeStep={activeStep} steps={steps} />
            <a
              href="/wizard/crm/settings"
              style={{
                display: 'block',
                textDecoration: 'none',
                marginTop: 25,
                position: 'relative',
                left: '-35px',
              }}
            >
              <ButtonContained
                full={true}
                type="button"
                color="primary"
                text="Далее"
              />
            </a>
            <p
              style={{
                position: 'relative',
                left: -34,
                fontFamily: 'Caveat, cursive',
                letterSpacing: 1.1,
                color: 'rgba(0, 0, 0, 0.6)',
                textAlign: 'right',
              }}
            >
              Вы сможете добавлять, изменять или удалять каналы для
              автоматической загрузки данных, а также вносить расходы вручную
              позже, из меню настроек.
            </p>
          </div>
          <div className={classes.wizardContent}>
            <Wrapper shadow={4}>
              <section className={classes.content}>
                <Typography
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: 10,
                    fontWeight: 'normal',
                    fontStyle: 'normal',
                    fontStretch: 'normal',
                    lineHeight: 1.6,
                    letterSpacing: 0.8,
                    color: '#000000',
                    padding: '10px 0',
                    marginLeft: -10,
                  }}
                >
                  <a href="/wizard/sources/settings" className={classes.back}>
                    <BackIcon width={24} height={24} stroke={'#000000'} />
                  </a>
                  Добавление рекламных площадок
                </Typography>
                <Typography variant="h3" paragraph>
                  Настройка ручного добавления затрат
                </Typography>

                {statistics && statistics.lenght ? (
                  <Fragment>
                    <Typography
                      variant="subtitle1"
                      component="div"
                      style={{
                        marginBottom: 8,
                        padding: '6px 13px 6px',
                        backgroundColor: 'rgba(255, 204, 0, .2)',
                      }}
                    >
                      <div style={{ margin: 0, fontWeight: 600 }}>
                        Обратите внимание:{' '}
                      </div>
                      <div style={{ margin: 0 }}>
                        пожалуйста, для корректного построения отчетов
                        указывайте сумму расходов с НДС.
                      </div>
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      paragraph
                      style={{
                        padding: '6px 13px 6px',
                        backgroundColor: 'rgba(136, 102, 255, .15)',
                      }}
                    >
                      Добавленные данные о расходах появятся в Google Analytics
                      в течение 24 часов.
                    </Typography>
                  </Fragment>
                ) : (
                  undefined
                )}

                {statistics && statistics.length ? (
                  <TableManualCosting data={statistics} />
                ) : (
                  <Fragment>
                    <p>Данных по расходам пока что нет.</p>
                    <Typography variant="subtitle1" paragraph>
                      Вы сможете заносить расходы по тем каналам, которые
                      недоступны для автоматического импорта, как только мы
                      начнем получать данные из вашего Google Analytics аккаунта
                      (получение данных происходит не реже чем раз в 15 минут).
                    </Typography>
                  </Fragment>
                )}
              </section>
            </Wrapper>
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(GAAsync)
